import { defineStore } from 'pinia';
import type { Scope } from '../services/StorageService';

interface FilemanagerData
{
    scope: Scope;
    folder: number;
}

export const useFilemanagerStore = defineStore('filemanager', () =>
{
    const filemanagerData = ref<FilemanagerData>({
        scope: 'public',
        folder: null
    });

    return { filemanagerData };
});
